import React, { useContext, useEffect, useRef, useState } from 'react'
import { SnackBarContext } from 'src/App'
import useFileUpload from 'react-use-file-upload'
import axios from 'axios'
import authHeader from 'src/services/auth-header'
import companyService from 'src/services/company.service'

const CompanyImageUpload = () => {
  const [fileUploading, setFileUploading] = useState(false)
  const [img, setImg] = useState('')

  const { setSuccessMessage, setErrorMessage } = useContext(SnackBarContext)
  const { files, setFiles, clearAllFiles } = useFileUpload()
  const inputRef = useRef()

  useEffect(() => {
    companyService.getCompanyLogo().then(resp => {
      setImg(resp.data.logoUrl)
    })
  }, [])

  useEffect(() => {
    if (files.length) {
      const formData = new FormData()
      formData.append('fileUpload', files[0])
      setErrorMessage(null)

      const allowedExtensions = ['.jpg', '.jpeg', '.png']
      const fileExtension = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase()

      if (!allowedExtensions.includes(fileExtension)) {
        setErrorMessage('Only .jpg or .png extentions allowed')
        clearAllFiles()
        setFileUploading(false)

        return
      }

      try {
        setFileUploading(true)
        axios
          .post(window._env_.REACT_APP_API_HOST + '/v1/companies/current/logo', formData, {
            'content-type': 'multipart/form-data',
            headers: authHeader()
            // responseType: 'blob'
          })
          .then(resp => {
            setFileUploading(false)
            clearAllFiles()
            setImg(resp.data.logoUrl)
            location.reload()

            if (resp.status == 200) {
              setSuccessMessage('Logo updated successfully.')
            }
          })
          .catch(async error => {
            clearAllFiles()
            const text = await error?.response?.data.text()
            const errorData = JSON.parse(text)
            setErrorMessage(errorData.description || 'Something went wrong')
            setFileUploading(false)
          })
      } catch (error) {
        console.error('Failed to submit files.')
      }
    }
  }, [files])

  return (
    <div className='row row-center select-image' style={{ marginBottom: 25, marginTop: 25 }}>
      <div
        onClick={() => inputRef.current.click()}
        style={{
          width: img ? '80px' : '50px',
          height: '50px',
          display: 'flex',
          borderRadius: img ? '0px' : '25px',
          overflow: 'hidden',
          backgroundColor: img ? 'transparent' : '#F4F5F9',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px',
          flexShrink: 0,
          cursor: 'pointer'
        }}
      >
        {img ? (
          <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={img} alt='' />
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#5F5F68',
              cursor: 'pointer'
            }}
          >
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M8 16V15H9V16H8ZM3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L3.70711 21.7071ZM7 21V16H9V21H7ZM8 17H3V15H8V17ZM8.70711 16.7071L3.70711 21.7071L2.29289 20.2929L7.29289 15.2929L8.70711 16.7071Z'
                fill='#76767d'
              />
              <path
                d='M12 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3H7C4.79086 3 3 4.79086 3 7V12'
                stroke='#76767d'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M8.5 8.5L11.7966 13.2616C12.4501 14.2055 13.7625 14.4067 14.6688 13.7018L16.1064 12.5838C16.9025 11.9645 18.0352 12.0351 18.7484 12.7483L21 14.9998'
                stroke='#76767d'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <circle cx='16.5' cy='7.5' r='1.5' fill='#76767d' />
            </svg>
          </div>
        )}
      </div>
      <input
        ref={inputRef}
        type='file'
        accept='.png, .jpg, .jpeg'
        style={{ display: 'none' }}
        onChange={e => {
          setFiles(e, 'a')
          inputRef.current.value = null
        }}
      />
      <div className='column' style={{ marginRight: 80 }}>
        <p
          className='select-image-title'
          style={{ fontSize: 14, fontWeight: 700, cursor: 'pointer' }}
          onClick={() => inputRef.current.click()}
        >
          Company Logo
        </p>
        <p style={{ color: '#76767D', fontSize: 14, cursor: 'pointer' }} onClick={() => inputRef.current.click()}>
          Click to upload your company logo <br />
          The logo will appear on the platform for a branded experience
        </p>
      </div>
    </div>
  )
}

export default CompanyImageUpload
